
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line

/**
 * RequestDirection enum
 */
class RequestDirection {
  /**
   * Initialize enum with a given value
   * @param {RequestDirection|number|Int64|UInt64=} value Enum value, defaults is 0
   * @constructor
   */
  constructor (value = 0) {
    if (value instanceof RequestDirection) {
      this.value = value.value
    } else {
      this.value = value
    }
  }

  /**
   * Is this enum equal to other one?
   * @this {!RequestDirection}
   * @param {!RequestDirection} other Other enum
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof RequestDirection)) {
      throw new TypeError('Instance of RequestDirection is required!')
    }
    return this.value === other.value
  }

  /**
   * Get enum value
   * @this {!RequestDirection}
   * @returns {!number|!Int64|!UInt64} Enum value
   */
  valueOf () {
    return this.value
  }

  /**
   * Convert enum to string
   * @this {!RequestDirection}
   * @returns {!string} Enum value string
   */
  toString () {
    if (this.value === RequestDirection.FORWARD.value) {
      return 'FORWARD'
    }
    if (this.value === RequestDirection.BACKWARD.value) {
      return 'BACKWARD'
    }
    return '<unknown>'
  }

  /**
   * Inspect enum
   * @this {!RequestDirection}
   * @returns {!string} Enum value string
   */
  [util.inspect.custom] () {
    return this.toString()
  }

  /**
   * Convert enum to JSON
   * @this {!RequestDirection}
   * @returns {!number} Enum value for JSON
   */
  toJSON () {
    return this.value
  }

  /**
   * Create enum from object value
   * @param {!number} other Object value
   * @returns {!RequestDirection} Created enum
   */
  static fromObject (other) {
    return new RequestDirection(other)
  }
}

// noinspection PointlessArithmeticExpressionJS
RequestDirection.FORWARD = new RequestDirection(0 + 0)
// noinspection PointlessArithmeticExpressionJS
RequestDirection.BACKWARD = new RequestDirection(0 + 1)

export { RequestDirection };

/**
 * Fast Binary Encoding RequestDirection field model
 */
class FieldModelRequestDirection extends fbe.FieldModel {
  /**
   * Get the field size
   * @this {!FieldModelRequestDirection}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 1
  }

  /**
   * Get the value
   * @this {!FieldModelRequestDirection}
   * @param {RequestDirection=} defaults Default value, defaults is new RequestDirection()
   * @returns {!RequestDirection} Result value
   */
  get (defaults = new RequestDirection()) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return defaults
    }

    return new RequestDirection(this.readByte(this.fbeOffset))
  }

  /**
   * Set the value
   * @this {!FieldModelRequestDirection}
   * @param {!RequestDirection} value Value
   */
  set (value) {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return
    }

    this.writeByte(this.fbeOffset, value.value)
  }
}

export { FieldModelRequestDirection };
